[
  {
    "id": "MET-M8P-L304-001",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Een vat van 200 liter loopt leeg met 50 ml per seconde. Hoe lang duurt het in seconden?",
    "options": ["4.000 seconden", "400 seconden", "2.000 seconden", "40.000 seconden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-STROOM",
    "explanation": "200 liter = 200.000 ml. 200.000 : 50 = 4.000 seconden.",
    "distractorExplanations": {
      "1": "Je vergat om te rekenen naar ml.",
      "2": "Je deed 200.000 : 100.",
      "3": "Je deed 200.000 : 5."
    }
  },
  {
    "id": "MET-M8P-L304-002",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Reken om: 0,000025 km² = ... dm²",
    "options": ["2.500 dm²", "250 dm²", "25 dm²", "25.000 dm²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-KM2-DM2",
    "explanation": "Van km² naar m² is ×1.000.000. Van m² naar dm² is ×100. Totaal ×100.000.000. 0,000025 × 100.000.000 = 2.500 dm².",
    "distractorExplanations": {
      "1": "Een nul te weinig.",
      "2": "Twee nullen te weinig.",
      "3": "Een nul te veel."
    }
  },
  {
    "id": "MET-M8P-L304-003",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Een driehoekig prisma heeft een inhoud van 60 cm³. De hoogte is 10 cm. Wat is de oppervlakte van het grondvlak?",
    "options": ["6 cm²", "600 cm²", "60 cm²", "3 cm²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-PRISMA-GRONDVLAK",
    "explanation": "Inhoud = grondvlak × hoogte. 60 = grondvlak × 10. Grondvlak = 6 cm².",
    "distractorExplanations": {
      "1": "Je deed ×10.",
      "2": "Dat is de inhoud.",
      "3": "Je deelde door 20."
    }
  },
  {
    "id": "MET-M8P-L304-004",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Hoeveel cm³ is 1,2 ml?",
    "options": ["1,2 cm³", "12 cm³", "120 cm³", "0,12 cm³"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-ML-CM3",
    "explanation": "1 ml is precies 1 cm³. Dus 1,2 ml = 1,2 cm³.",
    "distractorExplanations": {
      "1": "Je deed ×10.",
      "2": "Je deed ×100.",
      "3": "Je deed ÷10."
    }
  },
  {
    "id": "MET-M8P-L304-005",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Een trein rijdt 120 km/u. Hoeveel meter per seconde is dat? (afrond op 1 decimaal)",
    "options": ["33,3 m/s", "30 m/s", "40 m/s", "20 m/s"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-KMU-MS-COMPLEX",
    "explanation": "120 : 3,6 = 33,33... ≈ 33,3 m/s.",
    "distractorExplanations": {
      "1": "Je deelde door 4.",
      "2": "Je deelde door 3.",
      "3": "Je deelde door 6."
    }
  },
  {
    "id": "MET-M8P-L304-006",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Een cilinder heeft een straal van 5 cm en een hoogte van 12 cm. Wat is de inhoud in ml? (π = 3,14)",
    "options": ["942 ml", "471 ml", "1.884 ml", "314 ml"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-CILINDER-ML",
    "explanation": "Grondvlak = π × r² = 3,14 × 25 = 78,5 cm². Inhoud = 78,5 × 12 = 942 cm³ = 942 ml.",
    "distractorExplanations": {
      "1": "Je deed de inhoud : 2.",
      "2": "Je deed de inhoud × 2.",
      "3": "Je vergat de hoogte."
    }
  },
  {
    "id": "MET-M8P-L304-007",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Een blok aluminium is 2 dm × 1 dm × 0,5 dm. Aluminium weegt 2,7 kg/dm³. Hoeveel weegt het blok?",
    "options": ["2,7 kg", "5,4 kg", "1,35 kg", "27 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-SG-ALU",
    "explanation": "Inhoud = 2 × 1 × 0,5 = 1 dm³. 1 dm³ × 2,7 = 2,7 kg.",
    "distractorExplanations": {
      "1": "Dat is 2 dm³.",
      "2": "Dat is 0,5 dm³.",
      "3": "Dat is 10 dm³."
    }
  },
  {
    "id": "MET-M8P-L304-008",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Een park is 0,045 km². Hoeveel hectare is dat?",
    "options": ["4,5 ha", "45 ha", "0,45 ha", "450 ha"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-KM2-HA-M8P",
    "explanation": "1 km² = 100 ha. 0,045 × 100 = 4,5 ha.",
    "distractorExplanations": {
      "1": "Je deed ×1.000.",
      "2": "Je deed ×10.",
      "3": "Je deed ×10.000."
    }
  },
  {
    "id": "MET-M8P-L304-009",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Een kraan laat 2,5 liter per minuut lopen. Hoeveel liter loopt er in 1,5 uur?",
    "options": ["225 liter", "150 liter", "375 liter", "22,5 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-KRAAN",
    "explanation": "1,5 uur = 90 minuten. 90 × 2,5 = 225 liter.",
    "distractorExplanations": {
      "1": "Je deed 60 × 2,5.",
      "2": "Je deed 150 × 2,5.",
      "3": "Je deed 9 × 2,5."
    }
  },
  {
    "id": "MET-M8P-L304-010",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Reken om: 25 m/s = ... km/u",
    "options": ["90 km/u", "25 km/u", "250 km/u", "75 km/u"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-MS-KMU-M8P",
    "explanation": "Van m/s naar km/u: vermenigvuldigen met 3,6. 25 × 3,6 = 90 km/u.",
    "distractorExplanations": {
      "1": "Je zette niets om.",
      "2": "Je deed ×10.",
      "3": "Je deed ×3."
    }
  },
  {
    "id": "MET-M8P-L304-011",
    "module": "Metriek",
    "difficulty": 304,
    "question": "De oppervlakte van een cirkel is 200,96 cm². Wat is de straal? (π = 3,14)",
    "options": ["8 cm", "16 cm", "4 cm", "64 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-CIRKEL-STRAAL-M8P",
    "explanation": "Oppervlakte = π × r². 200,96 : 3,14 = 64. r² = 64. r = 8 cm.",
    "distractorExplanations": {
      "1": "Dat is de diameter.",
      "2": "Dat is de helft van de straal.",
      "3": "Dat is r²."
    }
  },
  {
    "id": "MET-M8P-L304-012",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Een bak van 80 cm × 50 cm × 40 cm is voor $\\frac{3}{4}$ gevuld met water. Hoeveel liter water zit erin?",
    "options": ["120 liter", "160 liter", "80 liter", "40 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-BAK-34",
    "explanation": "Totaal: 80 × 50 × 40 = 160.000 cm³ = 160 liter. $\\frac{3}{4}$ × 160 = 120 liter.",
    "distractorExplanations": {
      "1": "Dat is als de bak helemaal vol is.",
      "2": "Dat is de helft.",
      "3": "Dat is een kwart."
    }
  },
  {
    "id": "MET-M8P-L304-013",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Reken om: 0,0008 m³ = ... cl",
    "options": ["80 cl", "8 cl", "800 cl", "0,8 cl"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-M3-CL-M8P",
    "explanation": "0,0008 m³ = 0,8 liter = 80 cl.",
    "distractorExplanations": {
      "1": "Je deed 0,8 × 10.",
      "2": "Je deed 0,8 × 1.000.",
      "3": "Je deed 0,8 × 1."
    }
  },
  {
    "id": "MET-M8P-L304-014",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Een fietser rijdt 15 m/s. Hoeveel km/u is dat?",
    "options": ["54 km/u", "45 km/u", "150 km/u", "15 km/u"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-MS-KMU-FIETS",
    "explanation": "Van m/s naar km/u: ×3,6. 15 × 3,6 = 54 km/u.",
    "distractorExplanations": {
      "1": "Je deed ×3.",
      "2": "Je deed ×10.",
      "3": "Je zette niets om."
    }
  },
  {
    "id": "MET-M8P-L304-015",
    "module": "Metriek",
    "difficulty": 304,
    "question": "Een zwembad is 50 m lang, 25 m breed en 2 m diep. Hoeveel kubieke meter water past erin?",
    "options": ["2.500 m³", "250 m³", "25.000 m³", "77 m³"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-ZWEMBAD-M3",
    "explanation": "Inhoud = 50 × 25 × 2 = 2.500 m³.",
    "distractorExplanations": {
      "1": "Je deed 50 × 25 : 10.",
      "2": "Je deed 2.500 × 10.",
      "3": "Je telde de maten op."
    }
  }
]